import { useMapEvents } from "react-leaflet";
import { useCallback } from "react";
import { useStores } from "stores/setup/use-store";
import { getMacroRegionOriginFromPoint } from "util/macroRegion/getMacroRegionOriginFromPoint";
import { MacroRegion } from "enum/MacroRegion";
import { createCustomPoint } from "util/station/createCustomPoint";

export const MapClickHandler = () => {
  const {
    dataStores: {
      forecastChartPageStore,
      forecastChartMeteogramStore,
      regionStore,
    },
  } = useStores();
  useMapEvents({
    click: useCallback((e: { latlng: { lat: any; lng: any } }) => {
      const { lat, lng } = e.latlng;

      forecastChartMeteogramStore.setOpenMeteogram(true);
      forecastChartMeteogramStore.resetInsightMeteogram();

      forecastChartPageStore.setSelectedStation(0);
      forecastChartPageStore.setClickMapLatLng(e.latlng);
      forecastChartPageStore.setStationInfo();
      forecastChartPageStore.updateMacroRegionOrigin(
        { lat, lng },
        regionStore.macroRegions,
      );
      forecastChartPageStore.setActionCallMapClick();
    }, []),
  });

  return <> </>;
};

/**
 * Handler for map clicks in Point Selection Mode (for alerts).
 * Allows users to select any point on the map, not just existing stations.
 * station_id = 0 indicates this is a custom point, not an existing station.
 */
export const PointSelectionMapClickHandler = () => {
  const {
    dataStores: { insightAlertStore, regionStore, authStore },
  } = useStores();

  useMapEvents({
    click: useCallback(
      (e: {
        latlng: { lat: number; lng: number };
        originalEvent: MouseEvent;
      }) => {
        // Ignore clicks that originated from UI elements (buttons, inputs, etc.)
        const target = e.originalEvent?.target as HTMLElement;
        if (target) {
          // Check if click came from a button, input, or any interactive element
          const isInteractiveElement = target.closest(
            'button, input, [role="button"], .chakra-modal__content, .chakra-button, [data-prevent-map-click]',
          );
          if (isInteractiveElement) {
            return;
          }
        }

        const { lat, lng } = e.latlng;

        // Determine macro region for the clicked point
        const macroRegion = getMacroRegionOriginFromPoint(
          lat,
          lng,
          regionStore.macroRegions,
          authStore.userMarcroRegions as MacroRegion[],
        );

        // If point is outside user's allowed regions, show warning and don't select it
        if (!macroRegion) {
          insightAlertStore.setIsPointInvalid(true);
          return;
        }

        // Clear any previous invalid point warning
        insightAlertStore.setIsPointInvalid(false);

        // Create a virtual station object for the custom point
        const customPoint = createCustomPoint(lat, lng, macroRegion);

        insightAlertStore.setSelectedStationForAlert(customPoint, macroRegion);
        insightAlertStore.setMacroRegionOrigin(macroRegion);
      },
      [
        insightAlertStore,
        regionStore.macroRegions,
        authStore.userMarcroRegions,
      ],
    ),
  });

  return null;
};
